import { Box, Button, Modal } from "@mui/material";
import React from "react";
import { Component } from "react";
import CancelIcon from "@mui/icons-material/CancelOutlined"


export interface DtmfState {
    numbers: string;
    show: boolean;
}

class Dtmf extends Component<any, DtmfState> {
    constructor(props: any) {
        super(props)

        this.state = {
            numbers: "",
            show: false,
        }
    };


    componentDidMount() {

    }

    shouldComponentUpdate() {
        return true;
    }

    componentDidUpdate() {

    }

    componentWillUnmount() {

    }
    render() {
        const { t } = this.props
        const buttons = [
            {
                symbol: '1'
            },
            {
                symbol: '2',
                alias: 'abc'
            },
            {
                symbol: '3',
                alias: 'def'
            },
            {
                symbol: '4',
                alias: 'ghi'
            },
            {
                symbol: '5',
                alias: 'jkl'
            },
            {
                symbol: '6',
                alias: 'mno'
            },
            {
                symbol: '7',
                alias: 'pqrs'
            },
            {
                symbol: '8',
                alias: 'tuv'
            },
            {
                symbol: '9',
                alias: 'wxyz'
            },
            {
                symbol: '*'
            },
            {
                symbol: '0'
            },
            {
                symbol: '#'
            }
        ]
        const style = {
            position: 'absolute' as 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            minWidth: '300px',
            width: '20%',
            minHeight: '260px',
            height: '55%',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor:'darkgray',
            borderRadius: 10,
            padding: '15px'
        };
        return (
            <>
                <Modal
                    open={this.props.show}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <div style={{ width:'100%', height: '100%', display: 'flex', flexDirection: 'column'}}>
                            <div style={{ clear:'both', height:'25px', borderBottom: '1px solid #868686', margin: '0 20px', fontSize: 'larger' }}>
                            <span style={{'color': '#000', position:'relative' }}>{this.state.numbers}</span>
                            </div>
                            <div style={{
                                'margin': 0,
                                'padding': '0 20px',
                                'display': "flex",
                                'flexWrap': "wrap",
                                'flexGrow': 1,
                                'alignItems': 'center'
                            }}>
                                {buttons.map((button, i) => (
                                    <div key={i}
                                         style={{
                                             'flex': '1 1 25%',
                                             'margin': 'calc(2px + 0.1vh) calc(4px + 0.2vh)',
                                         }}>
                                        <Button onClick={
                                            ()=>{
                                                this.setState({ numbers: this.state.numbers + button.symbol })
                                                this.props.onDtmfClicked(button.symbol);
                                            }
                                        }
                                            style={{
                                                'borderWidth': '1px',
                                                'borderStyle': 'solid',
                                                'borderColor': '#4d4d4d',
                                                'color': '#000',
                                                'fontSize': 'calc(7px + 3vh)',
                                                'cursor': 'pointer',
                                                'width': '100%',
                                                'borderRadius': 10,
                                            }}>
                                            <strong>
                                                {button.symbol}
                                            </strong>
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        </div>

                    <Button style={{textAlign:'end'}} color="secondary" startIcon={<CancelIcon />}
                    onClick={this.props.handleShow}>{t('close_dialpad')}
                    </Button>
                    </Box>
                </Modal>
            </>
        );
    }
}

export default Dtmf;
